export enum TipoProdutoEnum {
    Simples = 1,
    Kit = 2,
    ComVariacao = 3,
    Fabricado = 4,
    MateriaPrima = 5
}